import { render } from "./whatsapp_groups.vue?vue&type=template&id=71d89807&scoped=true"
import script from "./whatsapp_groups.vue?vue&type=script&lang=js"
export * from "./whatsapp_groups.vue?vue&type=script&lang=js"

import "./whatsapp_groups.vue?vue&type=style&index=0&id=71d89807&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71d89807"]])

export default __exports__